import React, { useState } from 'react';

// Resumen del CRM de setting (spec §5.1): alertas arriba, agendadas contra la meta (y 6 semanas), actividad de hoy y
// de la semana, embudo de 4 semanas y velocidad. La meta la cambia solo el admin (el backend también lo exige).
const ACTIVIDAD = [
  ['aperturas', 'Aperturas'], ['respuestas', 'Respuestas'], ['seguimientos', 'Seguimientos'],
  ['a_agustin', 'Pasadas a Agustín'], ['mensajes_agustin', 'Mensajes de Agustín'],
];
const pct = (n, tope) => (tope > 0 ? Math.min(100, Math.round((100 * n) / tope)) : 0);
const fechaCorta = (dia) => {
  const [, m, d] = dia.split('-');
  return `${d}-${m}`;
};

const ResumenSetting = ({ resumen, esAdmin, onGuardarMeta }) => {
  const [meta, setMeta] = useState('');
  const [error, setError] = useState('');
  if (!resumen) return null;
  const {
    semana, semanas = [], actividad, embudo, velocidad: v, alertas = [],
  } = resumen;
  const tope = Math.max(semana.meta, ...semanas.map((s) => s.agendadas));

  const guardar = async () => {
    const n = Number(meta);
    if (!Number.isInteger(n) || n < 0) {
      setError('La meta va como un número entero.');
      return;
    }
    setError('');
    try {
      await onGuardarMeta(n);
      setMeta('');
    } catch (e) {
      setError(e?.response?.data?.error || 'No se pudo guardar la meta.');
    }
  };

  return (
    <div className="au-set-resumen">
      {alertas.length > 0 && (
        <ul className="au-set-alertas">{alertas.map((a) => <li key={a}>{a}</li>)}</ul>
      )}
      <section className="au-set-card">
        <h2 className="au-set-titulo">Agendadas esta semana</h2>
        <div className="au-set-grande">{`${semana.agendadas} de ${semana.meta}`}</div>
        <div className="au-set-barra"><div style={{ width: `${pct(semana.agendadas, semana.meta)}%` }} /></div>
        <div className="au-set-semanas">
          {semanas.map((s) => (
            <div key={s.desde} className="au-set-semana" title={`Semana del ${fechaCorta(s.desde)}`}>
              <div className="au-set-semana-barra" style={{ height: `${pct(s.agendadas, tope)}%` }} />
              <span className="mono">{s.agendadas}</span>
              <span className="muted mono">{fechaCorta(s.desde)}</span>
            </div>
          ))}
        </div>
        {esAdmin && (
          <div className="au-set-meta">
            <input
              type="number"
              min="0"
              aria-label="Meta semanal"
              placeholder={String(semana.meta)}
              value={meta}
              onChange={(e) => setMeta(e.target.value)}
            />
            <button type="button" className="au-set-btn" onClick={guardar} disabled={meta === ''}>Cambiar meta</button>
            {error && <span className="au-set-error">{error}</span>}
          </div>
        )}
      </section>
      <section className="au-set-card">
        <h2 className="au-set-titulo">Actividad</h2>
        <table className="au-set-tabla">
          <thead><tr><th aria-label="Qué" /><th>Hoy</th><th>Semana</th></tr></thead>
          <tbody>
            {ACTIVIDAD.map(([clave, etiqueta]) => (
              <tr key={clave}>
                <td>{etiqueta}</td>
                <td className="mono">{actividad.hoy[clave]}</td>
                <td className="mono">{actividad.semana[clave]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
      <section className="au-set-card">
        <h2 className="au-set-titulo">Embudo de las últimas 4 semanas</h2>
        <ol className="au-set-embudo">
          {embudo.pasos.map((p) => (
            <li key={p.clave}>
              <span>{p.etiqueta}</span>
              <span className="mono">{p.n}</span>
              <span className="muted mono">{p.pct === null ? '' : `${p.pct}%`}</span>
            </li>
          ))}
        </ol>
      </section>
      <section className="au-set-card">
        <h2 className="au-set-titulo">Velocidad y orden</h2>
        <dl className="au-set-velocidad">
          <dt>Tiempo de respuesta (mediana de la semana)</dt>
          <dd className="mono">{v.medianaMin === null ? 'sin datos' : `${v.medianaMin} min`}</dd>
          <dt>Ventanas perdidas (más de 24 h sin responder)</dt>
          <dd className="mono">{v.ventanasPerdidas}</dd>
          <dt>Seguimientos atrasados</dt>
          <dd className="mono">{v.seguimientosAtrasados}</dd>
          <dt>Ventanas que vencen en 3 horas</dt>
          <dd className="mono">{v.porVencer.cuantas}</dd>
        </dl>
      </section>
    </div>
  );
};

export default ResumenSetting;
